



















import {
  computed,
  defineComponent,
  getCurrentInstance,
  PropType
} from "@vue/composition-api";
import { sendGaEvent } from "@/helpers/ga-helper";
import { OccToggleCheckboxSize } from "./types";

export default defineComponent({
  name: "OccToggleCheckbox",
  inheritAttrs: false,
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    gaEventCategory: {
      type: String,
      default: ""
    },
    size: {
      type: String as PropType<OccToggleCheckboxSize>,
      default: OccToggleCheckboxSize.MEDIUM
    }
  },
  setup(props) {
    const isChecked = computed(() => {
      return props.checked;
    });
    const classes = computed(() => [
      isChecked.value ? "occ-toggle-checkbox--checked" : "",
      props.disabled ? "occ-toggle-checkbox--disabled" : ""
    ]);

    const instance = getCurrentInstance();
    const handleClick = () => {
      if (instance)
        sendGaEvent(instance.proxy, {
          gaEventLabel: {
            value: !isChecked.value,
            label: !isChecked.value ? "チェック" : "未チェック"
          }
        });
    };
    return { isChecked, classes, handleClick };
  }
});
